/**
 * Created by Mikhail Menshenin on 19.08.2024
 */

const ShieldsView = cc.Node.extend({
    ctor: function () {
        const styles = cleverapps.styles.ShieldsView;
        this._super();

        this.setAnchorPoint(0.5, 0.5);
        this.setScale2(styles.scale);

        const animation = this.animation = new cleverapps.Spine(bundles.shields.jsons.shield_animation);
        animation.setAlignment({ x: { align: "center" }, y: { align: "center" } });
        animation.setAnimation(0, "animation_00", false);
        this.setContentSize2(styles.size);
        this.addChild(animation);

        styles.targets.forEach((position, index) => {
            const num = index + 1;
            const target = new cc.Node();
            target.setContentSize(styles.target);
            target.setAlignment(position);
            this.addChild(target);
            cleverapps.aims.registerTarget(`shield${num}`, target, {
                controls: "shields",
                noTargetDelta: true
            });
        });

        this.updateShields(true);
        cleverapps.shields.on("change", this.updateShields.bind(this), this);
    },

    updateShields: function (silent) {
        const frame = cleverapps.shields.exceeded && !silent ? "animation_04"
            : `animation_0${cleverapps.shields.get()}`;
        this.animation.setAnimation(0, frame, false);
    }
});

cleverapps.styles.ShieldsView = {
    scale: [1.5, 1, 1],
    size: {
        width: 200,
        height: 85
    },
    target: {
        width: 74,
        height: 80
    },
    targets: [{
        x: { align: "center", dx: -38 },
        y: { align: "center" }
    }, {
        x: { align: "center", dx: 0 },
        y: { align: "center" }
    }, {
        x: { align: "center", dx: 37 },
        y: { align: "center" }
    }]
};